// src/components/ApplyForm.js
import React, { useState } from 'react';
import axios from 'axios';
import './ApplyForm.css';

const ApplyForm = ({ certification }) => {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // ✅ Correct backend URL + await axios
      const response = await axios.post("http://localhost:8080/api/apply", formData);

      if (response.data.success) {
        alert(`Thank you, ${formData.name}! Your application for ${certification} has been submitted successfully.`);
        setFormData({ name: '', company: '', email: '', phone: '', message: '' });
      } else {
        alert("Something went wrong! Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Server not reachable. Please check backend connection.");
    }
  };

  return (
    <div className="apply-form-container">
      <h3>Apply for {certification} Certification</h3>
      <form onSubmit={handleSubmit} className="apply-form">
        <input type="text" name="name" placeholder="Full Name *" required value={formData.name} onChange={handleChange} />
        <input type="text" name="company" placeholder="Company Name *" required value={formData.company} onChange={handleChange} />
        <input type="email" name="email" placeholder="Email Address *" required value={formData.email} onChange={handleChange} />
        <input type="tel" name="phone" placeholder="Phone Number *" required value={formData.phone} onChange={handleChange} />
        <textarea name="message" placeholder="Any specific requirements? (Optional)" rows="4" value={formData.message} onChange={handleChange}></textarea>
        <button type="submit" className="apply-btn">Submit Application</button>
      </form>
    </div>
  );
};

export default ApplyForm;
